import { z } from "zod";

/** A mailing-list email: trimmed, lower-cased, validated and length-bounded. */
export const subscriberEmailSchema = z.string().trim().toLowerCase().email().max(254);

/** Where an opt-in originated (free-form but bounded; today only the storefront). */
export const subscriberSourceSchema = z.string().trim().min(1).max(40);

/** A persisted mailing-list subscriber, as returned by the admin API. */
export const subscriberSchema = z
  .object({
    id: z.string(),
    email: z.string(),
    source: z.string(),
    createdAt: z.string(),
  })
  .strict();
export type Subscriber = z.infer<typeof subscriberSchema>;

/**
 * Payload the checkout handler sends to the mailingRegister worker (async Lambda
 * invoke, not an HTTP body). Validated the same way so a malformed event is a
 * no-op rather than a crash.
 */
export const registerSubscriberInputSchema = z
  .object({
    email: subscriberEmailSchema,
    source: subscriberSourceSchema.default("checkout"),
  })
  .strict();
export type RegisterSubscriberInput = z.infer<typeof registerSubscriberInputSchema>;
